import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit
} from '@angular/core';
import {
  ColumnDefinition,
  GridOptions,
  EventTypeFromGrid,
  Types
} from '../shared/grid.interface';
import { CustomService } from '../shared/grid-form.service';
import { getIndexFromArray, compareObjectsToDeleteRow } from '@tmhcc/util';
import { has } from 'libs/util/has-value';

@Component({
  selector: 'ac-grid-table',
  templateUrl: './grid-table.component.html',
  styleUrls: ['./grid-table.component.scss']
})
export class GridTableComponent implements OnInit, OnChanges, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  @Input() columnSettings: ColumnDefinition[];
  @Input() gridSetting: GridOptions;
  @Input() isCheckbox: boolean;
  @Input() isSelectAllCheckbox: boolean;
  @Input() isInfoIcon: boolean;
  @Input() isRadioBox: boolean;
  @Input() isDeleteOption: boolean;
  @Input() parentDivName: string;
  @Input() controlHeader = '';
  @Input() controlCheckHeader = '';
  @Input() controlInfoHeader = '';
  @Input() controlRadioHeader = '';
  @Input() records: any[];
  @Input() selectedRecords: any[];
  @Output() public eventForStandardGrid: EventEmitter<
    object
  > = new EventEmitter<object>();
  columnMaps: ColumnDefinition[];
  selectedValuesList: any = [];
  linkData: any;
  isAllCheckboxChecked: boolean;
  viewData: any;
  constructor(private customService: CustomService) {}

  ngOnInit() {
    //	this.dtOptions = this.customService.normalTableOptions();
  }

  ngOnChanges(): void {
    if (this.gridSetting) {
      if (
        this.gridSetting.hasOwnProperty('isPersist') &&
        this.gridSetting.isPersist == true
      ) {
        this.dtOptions = this.customService.setGridDataOptionsForVisibility(
          this.gridSetting,
          this.parentDivName
        );
      } else {
        this.dtOptions = this.customService.setGridDataOptions(
          this.gridSetting
        );
      }
    }

    if (!this.isCheckbox) {
      this.isCheckbox = false;
    }

    if (!this.isDeleteOption) {
      this.isDeleteOption = false;
    }

    if (!this.isRadioBox) {
      this.isRadioBox = false;
    }
    if (this.columnSettings) {
      // when settings provided
      this.setCustomData(this.columnSettings);
      //  this.columnMaps = this.columnSettings;
    }
  }

  ngAfterViewInit() {
    if (window.innerWidth <= 1200) {
      this.dtOptions.responsive = true;
    } else {
      this.dtOptions.responsive = false;
    }

    this.dtOptions.columnDefs = [
      {
        targets: this.returnNonSortable(),
        orderable: false,
        className: 'noVis',
        orderData: []
      }
    ];

    if (this.selectedRecords && this.selectedRecords.length > 0) {
      if (this.isCheckbox) {
        this.selectedRecords.forEach(element => {
          const index = getIndexFromArray(this.records, element);
          $('#' + this.parentDivName)
            .find('#checkBoxId_' + index)
            .prop('checked', true);
          this.selectedValuesList.push(element);
        });
        this.saveSelectedValues();
      }
      if (this.isRadioBox) {
        for (let i = 0; i < this.selectedRecords.length; i++) {
          const element = this.selectedRecords[i];
          const index = getIndexFromArray(this.records, element);
          $('#' + this.parentDivName)
            .find('#radioBoxId_' + index)
            .prop('checked', true);
          this.eventForStandardGrid.emit({
            key: EventTypeFromGrid.radioBox,
            divId: this.parentDivName,
            value: element
          });
          break;
        }
      }
      if (this.selectedRecords.length === this.records.length) {
        setTimeout(() => {
          this.isAllCheckboxChecked = true;
        }, 10);
      }
    }
  }

  selectAllCheckbox(event: any, value: any) {
    this.selectedValuesList = [];
    if (event.currentTarget.checked) {
      this.isAllCheckboxChecked = true;
      if (value) {
        this.selectedValuesList = [...value];
        this.records.forEach(value => {
          value.checkboxChecked = true;
        });
      }
    } else {
      this.isAllCheckboxChecked = false;
      this.records.forEach(value => {
        value.checkboxChecked = false;
      });
    }
    this.saveSelectedValues();
  }

  infoLinkEmiiter(element, value: any) {
    this.eventForStandardGrid.emit({
      key: EventTypeFromGrid.info,
      divId: this.parentDivName,
      value: value
    });
  }

  returnNonSortable() {
    const data = [];
    if (this.isCheckbox || this.isRadioBox) {
      data.push(0);
    }
    if (this.isDeleteOption) {
      if (this.isCheckbox || this.isRadioBox) {
        data.push(this.columnSettings.length + 1);
      } else {
        data.push(this.columnMaps.length);
      }
    }

    this.columnMaps.forEach((element, index) => {
      if (
        element.hasOwnProperty('isSortable') &&
        element.isSortable === false
      ) {
        if (this.isCheckbox || this.isRadioBox) {
          data.push(index + 1);
        } else {
          data.push(index);
        }
      }
    });
    return data;
  }

  selectCheckValue(e, value: any) {
    if (e.currentTarget.checked) {
      value.checkboxChecked = true;
      if (value) {
        this.selectedValuesList.push(value);
        this.saveSelectedValues();
      }
    } else {
      value.checkboxChecked = false;
      this.selectedValuesList.splice(
        getIndexFromArray(this.selectedValuesList, value),
        1
      );
      this.saveSelectedValues();
    }
    if (this.selectedValuesList.length == this.records.length) {
      this.isAllCheckboxChecked = true;
    } else {
      this.isAllCheckboxChecked = false;
    }
  }

  selectRadioValue(e, value: any) {
    if (e.currentTarget.checked) {
      if (value) {
        this.eventForStandardGrid.emit({
          key: EventTypeFromGrid.radioBox,
          divId: this.parentDivName,
          value: value
        });
      }
    }
  }

  saveSelectedValues() {
    this.eventForStandardGrid.emit({
      key: EventTypeFromGrid.checkBox,
      divId: this.parentDivName,
      value: this.selectedValuesList
    });
  }

  resetCheckBox() {
    this.selectedValuesList = [];
    //	$('input[type=checkbox]').prop('checked', false);
    $('#' + this.parentDivName)
      .find('input[type=checkbox]:checked')
      .prop('checked', false);
    $('#' + this.parentDivName)
      .find('input[type=radio]')
      .prop('checked', false);
  }

  selectedLink(selectedValue) {
    this.eventForStandardGrid.emit({
      key: EventTypeFromGrid.link,
      divId: this.parentDivName,
      value: selectedValue
    });
  }

  deleteRow(index) {
    this.eventForStandardGrid.emit({
      key: EventTypeFromGrid.delete,
      divId: this.parentDivName,
      value: index
    });
  }

  viewRowRecords(data) {
    this.eventForStandardGrid.emit({
      key: EventTypeFromGrid.view,
      divId: this.parentDivName,
      value: data
    });
  }

  setCustomData(fields) {
    this.columnMaps = [];
    fields.forEach(element => {
      if (element.columnType === Types.link) {
        if (has(element, 'alignment')) {
          element.alignItem = 'text-right';
        } else {
          element.alignItem = 'text-left';
        }
        this.linkData = element;
      } else if (element.columnType === Types.view) {
        this.viewData = element;
      } else {
        if (element.columnType === Types.currency) {
          element.alignItem = 'text-right';
        } else {
          element.alignItem = 'text-left';
        }
        this.columnMaps.push(element);
      }
    });
  }
}
